// Czech translations
export const cs: Record<string, string> = {
  'menu.dashboard': 'Nástěnka',
  'menu.orderNew': 'Registrace produktu',
  'menu.deliveryList': 'Seznam dodávek',
  'menu.delivery': 'Dodávka',
  'menu.receipt': 'Tisk účtenky/štítku',
  'menu.definitions': 'Definice',
  'menu.customers': 'Zákazníci',
  'menu.products': 'Definice produktů',
  'menu.pricing': 'Definice cen',
  'menu.tailoring': 'Krejčovské operace',
  'menu.attributes': 'Atributy produktů',
  'menu.users': 'Uživatelé',
  'menu.productOrdering': 'Řazení produktů',
  'menu.discounts': 'Definice slev',
  'menu.settings': 'Nastavení',
  'menu.generalSettings': 'Obecná nastavení',
  'menu.permissions': 'Správa oprávnění',
  'menu.subscription': 'Předplatné',
  'menu.invoices': 'Správa faktur',
  'menu.expenses': 'Zadávání výdajů',
  'menu.zReport': 'Z Report',
  'menu.reportsAndAccounting': 'Přehledy a účetnictví',
  'menu.systemAndCommunication': 'Systém a komunikace',
  'menu.reportsList': 'Seznam účtenek',
  'menu.accountStatement': 'Výpis z účtu',
  'menu.tickets': 'Žádosti o podporu',
  'menu.support': 'Podpora',
  'menu.profile': 'Profil',
  'menu.logout': 'Odhlásit se',
  'menu.notifications': 'Oznámení SMS/WhatsApp',
  'menu.whatsappConnection': 'Připojení WhatsApp',
  'menu.smsConnection': 'Připojení SMS',
  'dashboard.title': 'Nástěnka',
  'dashboard.todaySales': 'Dnešní tržby',
  'dashboard.totalOrders': 'Celkové objednávky',
  'dashboard.pendingDeliveries': 'Čekající dodávky',
  'dashboard.activeCustomers': 'Aktivní zákazníci',
  'dashboard.recentOrders': 'Nedávné objednávky',
  'dashboard.viewAll': 'Zobrazit vše',
  'dashboard.quickActions': 'Rychlé akce',
  'dashboard.newOrder': 'Nová objednávka',
  'dashboard.newCustomer': 'Nový zákazník',
  'dashboard.deliveries': 'Dodávky',
  'dashboard.reports': 'Zprávy',
  'dashboard.today': 'Dnes',
  'dashboard.yesterday': 'Včera',
  'dashboard.week': 'Týden',
  'dashboard.month': 'Měsíc',
  'dashboard.quarter': 'Čtvrtletí',
  'dashboard.year': 'Rok',
  'dashboard.totalRevenue': 'Celkové tržby',
  'dashboard.totalOrdersCard': 'Celkové objednávky',
  'dashboard.totalPieces': 'Celkové položky',
  'dashboard.cancelled': 'Zrušeno',
  'dashboard.inProcess': 'V procesu',
  'dashboard.inProcessDesc': 'Objednávky v procesu',
  'dashboard.ready': 'Připraveno',
  'dashboard.readyDesc': 'Objednávky připravené k dodání',
  'dashboard.delivered': 'Dodáno',
  'dashboard.deliveredDesc': 'Dokončené objednávky',
  'dashboard.announcements': 'Oznámení',
  'dashboard.announcementAll': 'Obecné',
  'dashboard.announcementPrivate': 'Soukromé',
  'order.title': 'Nová objednávka',
  'order.customer': 'Zákazník',
  'order.selectCustomer': 'Vybrat zákazníka',
  'order.newCustomer': 'Nový zákazník',
  'order.products': 'Produkty',
  'order.addProduct': 'Přidat produkt',
  'order.selectProduct': 'Vybrat produkt',
  'order.quantity': 'Množství',
  'order.price': 'Cena',
  'order.total': 'Celkem',
  'order.discount': 'Sleva',
  'order.subtotal': 'Mezisoučet',
  'order.tax': 'DPH',
  'order.grandTotal': 'Celková suma',
  'order.payment': 'Platba',
  'order.paymentMethod': 'Způsob platby',
  'order.cash': 'Hotovost',
  'order.card': 'Kreditní karta',
  'order.credit': 'Kredit',
  'order.amountPaid': 'Zaplacená částka',
  'order.remainingBalance': 'Zbývající zůstatek',
  'order.deliveryDate': 'Datum dodání',
  'order.notes': 'Poznámky',
  'order.createOrder': 'Vytvořit objednávku',
  'order.cancel': 'Zrušit',
  'users.title': 'Uživatelé',
  'users.addNew': 'Nový uživatel',
  'users.name': 'Jméno',
  'users.email': 'Email',
  'users.role': 'Role',
  'users.pin': 'PIN',
  'users.permissions': 'Oprávnění',
  'users.allPermissions': 'Všechna oprávnění',
  'users.permissionCount': '{count} oprávnění',
  'users.changePin': 'Změnit PIN',
  'users.edit': 'Upravit',
  'users.delete': 'Smazat',
  'users.newUser': 'Nový uživatel',
  'users.editUser': 'Upravit uživatele',
  'users.editingUser': 'Úprava {name}',
  'users.deleteUserTitle': 'Smazat uživatele',
  'users.deletingUser': 'Opravdu chcete smazat {name}?',
  'users.pinCode': 'PIN kód (4-6 číslic)',
  'users.selectRole': 'Vyberte roli',
  'users.patron': 'Majitel',
  'users.kasiyer': 'Pokladní',
  'users.sofor': 'Řidič',
  'users.changePinTitle': 'Změnit PIN kód',
  'users.newPin': 'Nový PIN kód',
  'users.confirmPin': 'Potvrdit PIN kód',
  'users.pinMismatch': 'PIN kódy se neshodují',
  'users.pinRequired': 'PIN kód je vyžadován',
  'users.pinLength': 'PIN kód musí mít 4-6 číslic',
  'users.changingPinFor': 'Změna PIN pro {name}',
  'products.title': 'Definice produktů',
  'products.addNew': 'Nový produkt',
  'products.category': 'Kategorie',
  'products.name': 'Název produktu',
  'products.price': 'Cena',
  'products.color': 'Barva',
  'products.active': 'Aktivní',
  'products.actions': 'Akce',
  'products.search': 'Vyhledat produkt...',
  'products.noProducts': 'Nebyly nalezeny žádné produkty',
  'products.noCategoryProducts': 'V této kategorii nejsou žádné produkty',
  'products.emptyCart': 'Košík je prázdný',
  'service.tailor': 'Krejčí',
  'service.dryCleaning': 'Čištění',
  'service.washing': 'Praní',
  'service.ironing': 'Žehlení',
  'service.shoeShine': 'Čištění obuvi',
  'service.carpet': 'Koberec',
  'service.tailoring': 'Krejčovské úpravy',
  'service.carpetWashing': 'Praní koberců',
  'service.selectService': 'Vybrat službu',
  'service.addToCart': 'Přidat do košíku',
  'service.total': 'Celkem',
  'common.yes': 'Ano',
  'common.no': 'Ne',
  'common.cancel': 'Zrušit',
  'common.confirm': 'Potvrdit',
  'common.delete': 'Smazat',
  'common.edit': 'Upravit',
  'common.save': 'Uložit',
  'common.search': 'Vyhledat',
  'common.loading': 'Načítání...',
  'common.noData': 'Žádná data',
  'common.actions': 'Akce',
  'common.status': 'Stav',
  'common.date': 'Datum',
  'common.time': 'Čas',
  'common.total': 'Celkem',
  'common.filter': 'Filtr',
  'common.export': 'Export',
  'common.print': 'Tisk',
  'common.close': 'Zavřít',
  'common.back': 'Zpět',
  'common.next': 'Next',
  'common.previous': 'Previous',
  'common.submit': 'Odeslat',
  'common.reset': 'Obnovit',
  'common.create': 'Vytvořit',
  'common.creating': 'Vytváření...',
  'common.later': 'Později',
  'common.clear': 'Vymazat',
  'common.copied': 'Zkopírováno!',
  'common.copyError': 'Kopírování se nezdařilo',
  'common.autoDetected': 'Automaticky detekováno',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.subtitle': 'Systém správy čištění',
  'login.tenantId': 'ID společnosti',
  'login.tenantPlaceholder': 'id-společnosti (např: acme-clean)',
  'login.tenantIdHelp': 'Zadejte jedinečný identifikátor společnosti',
  'login.continue': 'Pokračovat →',
  'login.notMember': 'Ještě nejste členem?',
  'login.startTrial': 'Zahájit bezplatnou zkušební verzi',
  'login.adminLogin': '🔒 Přihlášení správce',
  'login.enterPin': 'Zadejte svůj PIN kód',
  'login.changeTenant': 'Změnit společnost',
  'login.clear': 'Vymazat',
  'login.delete': 'Smazat',
  'login.login': 'Přihlásit se',
  'login.loggingIn': 'Přihlašování...',
  'login.defaultPinOwner': 'Výchozí PIN: <strong>1234</strong> (Majitel)',
  'login.defaultPinCashier': 'Výchozí PIN: <strong>0000</strong> (Pokladní)',
  'login.systemInitializing': 'Inicializace systému...',
  'login.pinMinLength': 'PIN musí mít alespoň 4 číslice',
  'login.invalidTenantId': 'Zadejte platné ID společnosti',
  'login.tenantNotFound': 'Tento kód společnosti nebyl nalezen. Zkontrolujte nebo vytvořte nový účet.',
  'login.loginFailed': 'Přihlášení se nezdařilo',
  'login.welcome': 'Vítejte, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.title': 'Zahájit bezplatnou zkušební verzi',
  'signup.subtitle': '15 dní zdarma, není potřeba kreditní karta',
  'signup.backToLogin': 'Zpět na přihlašovací stránku',
  'signup.companyCode': 'Kód společnosti',
  'signup.companyCodePlaceholder': 'např: cleanpro',
  'signup.companyCodeHelp': 'Tento kód bude použit pro přihlášení do systému',
  'signup.companyCodeMinLength': 'Kód společnosti musí mít alespoň 3 znaky',
  'signup.companyName': 'Název společnosti',
  'signup.companyNamePlaceholder': 'Název vaší společnosti',
  'signup.companyNameRequired': 'Název společnosti je povinný',
  'signup.fullName': 'Celé jméno',
  'signup.fullNamePlaceholder': 'Vaše celé jméno',
  'signup.fullNameRequired': 'Celé jméno je povinné',
  'signup.phone': 'Telefon',
  'signup.phonePlaceholder': '+420 777 123 456',
  'signup.validPhoneRequired': 'Zadejte platné telefonní číslo',
  'signup.email': 'Email',
  'signup.emailPlaceholder': 'example@company.com',
  'signup.validEmailRequired': 'Zadejte platnou emailovou adresu',
  'signup.createAccount': 'Vytvořit účet',
  'signup.creating': 'Vytváření...',
  'signup.terms': 'Vytvořením účtu souhlasíte s Podmínkami služby a Zásadami ochrany osobních údajů.',
  'signup.success': 'Registrace úspěšná! Vaše přihlašovací údaje byly odeslány na váš email.',
  'signup.successTitle': 'Registrace úspěšná!',
  'signup.successMessage': 'Váš účet byl úspěšně vytvořen.',
  'signup.emailSent': 'Vaše přihlašovací údaje byly odeslány na váš email.',
  'signup.redirecting': 'Přesměrování na přihlašovací stránku...',
  'signup.startupPackageLoaded': 'Startovací balíček načten!',
  'signup.products': 'Produkty',
  'signup.customers': 'Zákazníci',
  'signup.users': 'Uživatelé',
  'signup.demoDataReady': '✨ Vaše demo data jsou připravena, můžete je okamžitě začít používat!',
  'signup.loginInfo': '📧 Vaše přihlašovací údaje',
  'signup.loginInfoSent': '💡 Tyto informace byly také odeslány na váš email',
  'signup.loginNow': 'Přihlásit se nyní →',
};
